import { Locale, getLocale } from '@libs/core';

const scriptId = {
    [Locale['en-US']]: process.env.NEXT_PUBLIC_MEDALLIA_ID_US,
    [Locale['en-CA']]: process.env.NEXT_PUBLIC_MEDALLIA_ID_CA,
}[getLocale()];

export const MEDALLIA_SCRIPT_SRC = scriptId
    ? `https://resources.digital-cloud.medallia.com/wdcus/${scriptId}/onsite/embed.js`
    : null;
